








































import { Vue, Component } from 'vue-property-decorator';
import { Dialog, Toast, Popup } from 'vant';
import * as config from './config';
import { isWeiXin } from '@/common/ts/common';
import { isSave } from './api';
Vue.use(Toast)
  .use(Popup)
  .use(Dialog);
@Component({
  components: {},
})
export default class Third extends Vue {
  option = config.OPTHINES;
  ThirdArr = ['重庆100佳民心科室', '重庆100佳民心医师'];
  currentClass: any;
  pointOut = false;
  created() {
    this.$appShareInfo({
      title: '健康民心“双百”口碑榜',
      url: window.location.href,
      subtitle: '第三届医师节千万网民点赞的“100佳民心医师和100佳民心科室”活动',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    this.$wxShareInfo({
      title: '健康民心“双百”口碑榜',
      subtitle: '第三届医师节千万网民点赞的“100佳民心医师和100佳民心科室”活动',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  handleClickTab(curClass: any): void {
    if (!window.udid) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行报名',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        overlay: true,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else {
      this.currentClass = curClass + 1;
      const data = {
        type: curClass + 1,
        udid: window.udid,
        appkey: window.appkey,
      };
      isSave(data).then((res) => this.handleClickNext(res));
    }
  }
  handleClickNext(res: any) {
    if ((res as any).code === 200) {
    this.$router.push({
      path: 'Upload',
      query: {
        type: this.currentClass,
      },
    });
    } else {
      Toast.fail(res.msg);
    }

  }
}
